const socialStreamMenuItems = []

socialStreamMenuItems.push({
  route: 'socialStreamConfigs',
  title: 'menu.socialStream.configsList',
})

const socialStreamMenu = {
  title: 'menu.socialStream.title',
  icon: 'InstagramIcon',
  i18n: 'menu.socialStream.title',
  slug: 'socialStream',
  children: socialStreamMenuItems
}

export default socialStreamMenu